import React, { useState, useEffect } from "react";
import LabelValueRow from "../../LabelValueRow";

// LIBERA PROFESSIONE ENPALS
const LiberaProfessioneEnpalsWidget = ({
  setContributiTotali,
  redditoPrevidenziale,
  isFullTime,
}) => {
  const [factors] = useState({
    contribuzione: 0.33,
    committente: 0.0919,
    compenso: 0.2381,
  });

  const [contributi, setContributi] = useState({
    totali: 0,
    committente: 0,
    compenso: 0,
  });

  useEffect(() => {
    setContributi({
      totali: redditoPrevidenziale * factors.contribuzione,
      committente: redditoPrevidenziale * factors.committente,
      compenso: redditoPrevidenziale * factors.compenso,
    });
    setContributiTotali(redditoPrevidenziale * factors.contribuzione);
  }, [
    setContributiTotali,
    redditoPrevidenziale,
    factors.contribuzione,
    factors.committente,
    factors.compenso,
  ]);

  return (
    <>
      <div className="flex flex-row justify-between items-center bg-gray-100 px-4 border-b-2 pb-2 pt-2 dark:bg-gray-600 w-[100%]">
        <div className="flex flex-col text-left">
          <span className="text-gray-400">La cassa ex ENPALS (ora FPS)</span>
          <div className="text-sm leading-[1.2] dark:text-gray-400">
            Prevede un calcolo contributivo diverso rispetto la norma.
            <a
              className="pl-1 text-orange-400"
              href="https://www.inps.it/prestazioni-servizi/denuncia-e-versamento-dei-contributi-ex-enpals-fondo-pensioni-lavoratori-dello-spettacolo-e-fondo-pensioni-sportivi-professionisti"
              target="_blank"
              rel="noreferrer"
            >
              Maggiori informazioni qui
            </a>
          </div>
        </div>
      </div>
      {isFullTime === "1" && (
        <div className="flex flex-row justify-between items-center bg-gray-100 px-4 mb-4 pb-2 pt-2 dark:bg-gray-600 w-[100%]">
          <div className="flex flex-col text-left">
            <span className="text-gray-400">Sei già dipendente full time</span>
            <div className="text-sm leading-[1.2] dark:text-gray-400"></div>
          </div>
        </div>
      )}
      <LabelValueRow
        label="Contributi a carico del datore di lavoro"
        value={contributi.committente}
        important={false}
      />
      <LabelValueRow
        label="Contributi a tuo carico"
        value={contributi.compenso}
        important={false}
      />
      <LabelValueRow
        label="Contributi totali"
        value={contributi.totali}
        important={true}
      />
    </>
  );
};

export default LiberaProfessioneEnpalsWidget;
